import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['button', 'template']

  connect() {
    this.clonedContent = []
    for (let node of this.buttonTarget.children) {
      this.clonedContent.push(node)
    }
  }

  disable() {
    this.buttonTarget.disabled = true
    if (this.hasTemplateTarget) {
      let templateContent = this.templateTarget.content.cloneNode(true)
      this.buttonTarget.innerHTML = ''
      this.buttonTarget.append(templateContent)
    }
  }

  enable() {
    if (this.hasTemplateTarget) {
      this.buttonTarget.innerHTML = ''
      this.buttonTarget.append(...this.clonedContent)
    }
    this.buttonTarget.disabled = false
  }
}
